import * as Constants from './shared/constants';
import { getTelemetry } from './Telemetry/Telemetry';

const msaDiscoveryResponseErrorKey = 'error';
const msaDiscoveryResponseUsernameKey = 'username';
const msaResponsePrefix = 'msa';


enum MsaDiscoveryResponseErrorType {
  login = 'msa_auth',
  signUp = 'msa_signup',
}

interface IMsaDiscoveryResponse {
  error: string;
  username: string;
}

export const msaDiscovery = (searchParams: string) => {
  const msaDiscoveryResponse = getMsaDiscoveryResponse(searchParams.toLowerCase());
  if (isValidMsaDiscoveryResponse(msaDiscoveryResponse)) {
    addMsaDetectTelemetry(msaDiscoveryResponse);
    msaRedirect();
  }
};

const getMsaDiscoveryResponse = (searchParams: string): IMsaDiscoveryResponse => {
  const queryParams = new URLSearchParams(searchParams);
  const username = queryParams.get(msaDiscoveryResponseUsernameKey) || '';
  const error = queryParams.get(msaDiscoveryResponseErrorKey) || '';
  return {
    error,
    username,
  };
};

const isValidMsaDiscoveryResponse = (response: IMsaDiscoveryResponse) => {
  return response.error.includes(msaResponsePrefix);
};

const addMsaDetectTelemetry = (msaDiscoveryResponse: IMsaDiscoveryResponse) => {
  const { error } = msaDiscoveryResponse;
  const telemetry = getTelemetry();
  switch (error) {
    case MsaDiscoveryResponseErrorType.signUp:
      telemetry.reportCustomEvent('msa-discovery/sign-up/detected', { message: 'MSA sign up attempt detected' });
      break;
    case MsaDiscoveryResponseErrorType.login:
      telemetry.reportCustomEvent('msa-discovery/login/detected', { message: 'MSA account login attempt detected' });
      break;
    default:
      telemetry.error('msa-discovery/unknown-error', { error: 'Unknown error detected' });
  }
};

const msaRedirect = () => {
  location.replace(Constants.msaRedirectUrl);
};
